import React from 'react'
import { Chip } from "@material-ui/core";
import axios from "axios";
import { useEffect } from "react";


const Genres = ({
    selectedGenres,
    setSelectedGenres,
    genres,
    setGenres,
    type,
    setPage,
  }) => {
    const handleAdd = (genre) => {
        setSelectedGenres([...selectedGenres, genre]);
        setGenres(genres.filter((g) => g.id !== genre.id));
        setPage(1);
      };
    
  const handleRemove = (genre) => {
    setSelectedGenres(
      selectedGenres.filter((selected) => selected.id !== genre.id)
    );
    setGenres([...genres, genre]);
    setPage(1);
  };

    const fetchGenres = async () => {
        const { data } = await axios.get(`https://api.themoviedb.org/3/genre/${type}/list?api_key=16d05b1ea65094d893b14e9c9241bf31&language=en-US`)    
        setGenres(data.genres);
      };
      useEffect(() => {
        fetchGenres();
        return () =>{
            setGenres({}); 
        }
      }, []);

    return (
    <div style={{ padding: "6px 0" }}>
      {selectedGenres.map((genre) => (
          
        <Chip
          style={{ margin: 2 , color:'black', fontWeight: "bold" }}
          label={genre.name}
          key={genre.id}
          color="secondary"
          clickable
          size="medium"
          onDelete={() => handleRemove(genre)}
        //   variant="outlined"
        />
      ))}
      {genres.map((genre) => (
        <Chip
          style={{  margin: 2 , color:'black', fontWeight: "bold" }}
          label={genre.name}
          key={genre.id}
          clickable
          size="medium"
        //   variant="outlined"
          onClick={() => handleAdd(genre)}
        />
      ))}
    </div>
    )
}

export default Genres
